import api from './api';

export type DocAudience = 'operator' | 'agent';

export interface TocNode {
  level: number;
  title: string;
  anchor: string;
  children: TocNode[];
}

export interface DocCatalogEntry {
  slug: string;
  title: string;
  group: string;
  summary: string | null;
  audience: DocAudience[];
  last_updated: string;        // ISO 8601
  sidebar_collapsed: boolean;
  sidebar_recent_limit: number | null;
  toc: TocNode[];              // empty = no headings / older manifest
}

export interface CatalogResponse {
  groups: string[];
  default_slug: string;
  docs: DocCatalogEntry[];
}

export interface DocResponse {
  slug: string;
  title: string;
  content: string;
  last_updated: string;
}

export async function listDocs(): Promise<CatalogResponse> {
  const { data } = await api.get<CatalogResponse>('/docs/list');
  return data;
}

export async function getDoc(slug: string): Promise<DocResponse> {
  const { data } = await api.get<DocResponse>(
    `/docs/${encodeURIComponent(slug)}`,
  );
  return data;
}
